module.exports = __webpack_public_path__ + "img/dimsum-uncutted-background.57c49960.png";